import type {AnalysisOptions} from "./AnalysisOptions.ts";
import type {Setter} from "../../util/setter/Setter.ts";
import {useFieldSetter} from "../../util/setter/FieldSetter.ts";
import {CheckboxField} from "../../components/checkbox-field/CheckboxField.tsx";

interface Props {
    options: AnalysisOptions
    setOptions: Setter<AnalysisOptions>
}
export function OptionalScanOptionsWidget({options, setOptions}: Props) {
    const [analyseGit, setAnalyseGit] = useFieldSetter(options, setOptions, "analyseGit")
    const [analyseApiProfiles, setAnalyseApiProfiles] = useFieldSetter(options, setOptions, "analyseApiProfiles")
    const [analyseWebhooks, setAnalyseWebhooks] = useFieldSetter(options, setOptions, "analyseWebhooks")
    const [analyseOauthConnections, setAnalyseOauthConnections] = useFieldSetter(options, setOptions, "analyseOauthConnections")
    const [analysePasswords, setAnalysePasswords] = useFieldSetter(options, setOptions, "analysePasswords")
    const [analyseCloudCredentials, setAnalyseCloudCredentials] = useFieldSetter(options, setOptions, "analyseCredentials")
    const [analyseQueueConfig, setAnalyseQueueConfig] = useFieldSetter(options, setOptions, "analyseQueueConfig")

    return <div>
        <h3>Optional Scans</h3>
        <CheckboxField title="Analyse Git"
                       description="Scan Git/SCM configurations for projects"
                       small
                       value={analyseGit} setValue={setAnalyseGit} />
        <CheckboxField title="Analyse API Profiles"
                       description="Scan API Query and API Extract profiles"
                       small
                       value={analyseApiProfiles} setValue={setAnalyseApiProfiles} />
        <CheckboxField title="Analyse Webhooks"
                       description="Scan error reporting and webhook configurations"
                       small
                       value={analyseWebhooks} setValue={setAnalyseWebhooks} />
        <CheckboxField title="Analyse OAuth Connections"
                       description="Scan OAuth connection configurations"
                       small
                       value={analyseOauthConnections} setValue={setAnalyseOauthConnections} />
        <CheckboxField title="Analyse Password Types"
                       description="Scan password types across groups. This does not scan password contents, only the type of password storage."
                       small
                       value={analysePasswords} setValue={setAnalysePasswords} />
        <CheckboxField title="Analyse Cloud Credential Types"
                       description="Scan cloud credentials. This does not scan credential secrets, only the types."
                       small
                       value={analyseCloudCredentials} setValue={setAnalyseCloudCredentials} />
        <CheckboxField title="Analyse Queue Configuration"
                       description="Scan queue configuration"
                       small
                       value={analyseQueueConfig} setValue={setAnalyseQueueConfig} />

    </div>
}